/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignComputedTagFunction } from '../fn/computed-tags-functions/assign-computed-tag-function';
import { AssignComputedTagFunction$Params } from '../fn/computed-tags-functions/assign-computed-tag-function';
import { getAllComputedTagsFunction } from '../fn/computed-tags-functions/get-all-computed-tags-function';
import { GetAllComputedTagsFunction$Params } from '../fn/computed-tags-functions/get-all-computed-tags-function';
import { getComputedTagsFunction } from '../fn/computed-tags-functions/get-computed-tags-function';
import { GetComputedTagsFunction$Params } from '../fn/computed-tags-functions/get-computed-tags-function';
import { TagComputedFunctionInfos } from '../models/tag-computed-function-infos';
import { TagComputedFunctionInfosList } from '../models/tag-computed-function-infos-list';


/**
 * All about the computed tags functions
 */
@Injectable({ providedIn: 'root' })
export class ComputedTagsFunctionsService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllComputedTagsFunction()` */
  static readonly GetAllComputedTagsFunctionPath = '/custom/stations/{uid}/tags-computed-function';

  /**
   * Get the computed tags for a station.
   *
   * Allows to get the computed tags for a station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllComputedTagsFunction()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllComputedTagsFunction$Response(params: GetAllComputedTagsFunction$Params, context?: HttpContext): Observable<StrictHttpResponse<TagComputedFunctionInfosList>> {
    return getAllComputedTagsFunction(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the computed tags for a station.
   *
   * Allows to get the computed tags for a station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllComputedTagsFunction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllComputedTagsFunction(params: GetAllComputedTagsFunction$Params, context?: HttpContext): Observable<TagComputedFunctionInfosList> {
    return this.getAllComputedTagsFunction$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagComputedFunctionInfosList>): TagComputedFunctionInfosList => r.body)
    );
  }

  /** Path part for operation `getComputedTagsFunction()` */
  static readonly GetComputedTagsFunctionPath = '/custom/stations/{uid}/tags-computed-function/{tagUid}';

  /**
   * Get the computed tags for a station.
   *
   * Allows to get a computed tag for a station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getComputedTagsFunction()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComputedTagsFunction$Response(params: GetComputedTagsFunction$Params, context?: HttpContext): Observable<StrictHttpResponse<TagComputedFunctionInfos>> {
    return getComputedTagsFunction(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the computed tags for a station.
   *
   * Allows to get a computed tag for a station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getComputedTagsFunction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComputedTagsFunction(params: GetComputedTagsFunction$Params, context?: HttpContext): Observable<TagComputedFunctionInfos> {
    return this.getComputedTagsFunction$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagComputedFunctionInfos>): TagComputedFunctionInfos => r.body)
    );
  }

  /** Path part for operation `assignComputedTagFunction()` */
  static readonly AssignComputedTagFunctionPath = '/custom/stations/{uid}/tags-computed-function/{tagUid}';

  /**
   * Assign a function to a computed tag.
   *
   * Allows to assign a function to a computed tag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignComputedTagFunction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignComputedTagFunction$Response(params: AssignComputedTagFunction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignComputedTagFunction(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign a function to a computed tag.
   *
   * Allows to assign a function to a computed tag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignComputedTagFunction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignComputedTagFunction(params: AssignComputedTagFunction$Params, context?: HttpContext): Observable<void> {
    return this.assignComputedTagFunction$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
